import { eTipoPermissao } from '@/enums/ePermissoes';
export default [
  {
    description: 'Dados do Aluno {pdiSigla} (Res. 4256)',
    path: '/educacaoinclusiva/pdi-res4256',
    name: 'pdi_res4256',
    component: () => import('@/views/educacaoinclusiva/pdi-res4256/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.NOVO_PDI_RES_4256_MENU_390000070],
    },
    goesToMenu: true,
  },
];
